export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/mute-icon.svg?a862c5724da7cdd59c1b5303fb3e9814";